import { computed } from '@ember/object';
import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export const UsageUnitType = new Enum(['INVALID', 'EMPLOYEE', 'RETAIL_DEVICE', 'CUSTOMER', 'APPOINTMENTS_EMPLOYEE', 'RESTAURANTS_LOCATION', 'RESTAURANTS_ADDITIONAL_DEVICE', 'RESTAURANTS_MOBILE_LOCATION', 'RETAIL_LOCATION', 'RETAIL_ADDITIONAL_DEVICE', 'EMPLOYEE_MANAGEMENT_LOCATION', 'SPOS_DEVICE_SETTINGS_DEVICE', 'REACHABLE_CONTACTS', 'LOYALTY_LOCATIONS', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3', 'LOYALTY_TRANSACTIONS', 'LOYALTY_TRANSACTIONS_TIER', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2', 'LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3', 'MARKETING_SMS_MESSAGES', 'KDS_DEVICE', 'APPOINTMENTS_LOCATIONS', 'PAYROLL_EMPLOYEE', 'SHIFTS_TEAM_MEMBER', 'ECOM_ACCOUNT', 'MESSAGES_LOCATION', 'HR_TOOLKIT_EMPLOYEE', 'HR_MANAGER_EMPLOYEE', 'STAFF_TEAM_MEMBER', 'HR_MANAGER_TEAM_MEMBER', 'PAYROLL_MAILED_TAX_FORM', 'STAFF_LOCATION', 'FNB_KIOSK_DEVICE', 'FRANCHISE_LOCATION', 'RESTAURANTS_MOBILE_DEVICE', 'LOYALTY_PAYG_USAGE', 'LOYALTY_PAYG_LOCATION', 'COMMS_TEAM_MEMBER']);
const unitTypeMapping = {
  INVALID: 'INVALID',
  EMPLOYEE: 'EMPLOYEE',
  RETAIL_DEVICE: 'DEVICE',
  CUSTOMER: 'CUSTOMER',
  APPOINTMENTS_EMPLOYEE: 'EMPLOYEE',
  RESTAURANTS_LOCATION: 'LOCATION',
  RESTAURANTS_ADDITIONAL_DEVICE: 'DEVICE',
  FNB_KIOSK_DEVICE: 'DEVICE',
  RESTAURANTS_MOBILE_DEVICE: 'DEVICE',
  RESTAURANTS_MOBILE_LOCATION: 'LOCATION',
  RETAIL_LOCATION: 'LOCATION',
  RETAIL_ADDITIONAL_DEVICE: 'DEVICE',
  KDS_DEVICE: 'DEVICE',
  PAYROLL_EMPLOYEE: 'EMPLOYEE',
  SHIFTS_TEAM_MEMBER: 'EMPLOYEE',
  ECOM_ACCOUNT: 'LOCATION',
  EMPLOYEE_MANAGEMENT_LOCATION: 'LOCATION',
  MESSAGES_LOCATION: 'LOCATION',
  COMMS_TEAM_MEMBER: 'EMPLOYEE'
};
export function normedUnitTypeFor(unitType) {
  return unitTypeMapping[unitType];
}
export const SingleUnitUsage = ProtoBaseModel.extend({
  unitType: attr(UsageUnitType),
  count: attr(Number),
  normedUnitType: computed('unitType', function () {
    return normedUnitTypeFor(this.unitType);
  })
});
export default ProtoBaseModel.extend({
  unitUsages: repeated(SingleUnitUsage)
});